module.exports = __webpack_public_path__ + "img/table.1fced844.png";